import {
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
} from '@aboutyou/legacy-tracking-sdk'
import { getCdnModelImageUrl } from 'helpers/product/images'
import { ElementTrackingContextProvider } from 'helpers/tracking/ElementTrackingContext'
import { OutfitPromotionTracker } from 'helpers/tracking/trackerComponents/ElementTracker'
import React, { FC, memo } from 'react'
import { useService } from 'services/utils/context'
import OutfitRecoTile from 'uiComponents/molecules/ProductStreamElements/OutfitRecoTile'

interface Props {
  outfitId: string
  disableContent?: boolean
  onClick?: VoidFunction
}

const OutfitTileConnected: FC<Props> = ({
  outfitId,
  disableContent,
  onClick = () => null,
}) => {
  const service = useService()
  const outfit = service.outfits.getById(outfitId)

  if (!outfit) {
    return null
  }

  const imageHash = outfit.hotspotImageHash
    ? outfit.hotspotImageHash
    : outfit.idol.imageHash

  return (
    <OutfitPromotionTracker<HTMLAnchorElement>
      cachePageImpression
      outfitId={outfit.id}
    >
      {({ onClickCapture, ref }) => (
        <OutfitRecoTile
          ref={ref}
          onClick={() => {
            onClick()
            onClickCapture()
          }}
          href={outfit.url}
          imageSource={getCdnModelImageUrl(imageHash)}
          idolName={outfit.idol.name}
          disableContent={disableContent}
        />
      )}
    </OutfitPromotionTracker>
  )
}

const OutfitTileConnectedWithTracking: FC<
  Props & {
    loading?: boolean
    pageType?: TrackingPageTypeWithId | TrackingPageTypeWithoutId
  }
> = ({ loading, ...props }) => (
  <ElementTrackingContextProvider
    disabled={loading}
    id={Number(props.outfitId)}
    type="outfit"
  >
    <OutfitTileConnected {...props} />
  </ElementTrackingContextProvider>
)

export default memo(OutfitTileConnectedWithTracking)
